import { render, staticRenderFns } from "./guru.vue?vue&type=template&id=05525949&"
import script from "./guru.vue?vue&type=script&lang=js&"
export * from "./guru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports